import { CharStatus } from '../../lib/statuses'
import classnames from 'classnames'
import { REVEAL_TIME_MS } from '../../constants/settings'

type Props = {
  value?: string
  status?: CharStatus
  isRevealing?: boolean
  isCompleted?: boolean
  hidden?: boolean
  position?: number
  isHighContrast?: boolean
}

export const Cell = ({
  value,
  status,
  isRevealing,
  isCompleted,
  hidden,
  position = 0,
  isHighContrast
}: Props) => {
  const isFilled = value && !isCompleted
  const shouldReveal = isRevealing && isCompleted
  const animationDelay = status !== 'revealed' ? `${position * REVEAL_TIME_MS}ms` : '0ms';

  const classes = classnames(
    'w-7 h-7 sm:w-8 sm:h-8 md:w-14 md:h-14 border-solid border-2 flex items-center justify-center mx-0.5 text-lg sm:text-xl md:text-4xl select-none font-bold dark:text-white',
    {
      'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-600':
        !status,
      'border-slate-400 dark:border-slate-700': value && !status,
      'absent shadowed bg-slate-400 dark:bg-slate-700 text-white border-slate-400 dark:border-slate-700':
        status === 'absent',
      'correct shadowed bg-orange-500 text-white border-orange-500':
        status === 'correct' && isHighContrast,
      'present shadowed bg-cyan-500 text-white border-cyan-500':
        status === 'present' && isHighContrast,
      'correct shadowed bg-green-500 text-white border-green-500':
        status === 'correct' && !isHighContrast,
      'present shadowed bg-yellow-500 text-white border-yellow-500':
        status === 'present' && !isHighContrast,
      'cell-force-revealed shadowed bg-slate-800 text-white border-slate-800':
        status === 'revealed',
      'cell-fill-animation': isFilled,
      'cell-reveal': shouldReveal,
      'transition-opacity opacity-0 duration-500': hidden
    }
  )

  return (
    <div className={classes} style={{ animationDelay }}>
      <div className="letter-container" style={{ animationDelay }}>
        {value}
      </div>
    </div>
  )
}
